import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { makeStyles, withStyles } from '@mui/styles';

import Text from '../../../react-components/Text';

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: `#E0E0E0`,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    // boxShadow: `none`,
    // '&:nth-of-type(odd)': {
    //   backgroundColor: theme.palette.action.hover,
    // },
  },
}))(TableRow);

const useStyles = makeStyles({
  table: {
    minWidth: 700,
    boxShadow: `none`,
  },
  sticky: {
    position: `sticky`,
    left: 0,
    background: `white`,
    backgroundClip: `padding-box`, // See this https://developer.mozilla.org/en-US/docs/web/css/background-clip
    borderRight: `1px solid #E0E0E0`,
  },
});

export type AlignmentTypes = `left` | `right` | `inherit` | `center` | `justify`;

interface AnalyticsTableProps {
  docs?: Record<string, any>[];
  mapping: {
    style?: any;
    width?: number | string;
    height?: number;
    align?: AlignmentTypes;
    column?: any;
    name?: any;
    computed?: any;
    formatter?: any;
  }[];
}

const AnalyticsTable = ({ docs, mapping }: AnalyticsTableProps) => {
  const classes = useStyles();

  return (
    <TableContainer
      style={{
        border: `1px solid #E0E0E0`,
        borderBottom: `none`,
      }}
    >
      <Table className={classes.table} aria-label="analytics table">
        <TableHead>
          <TableRow>
            {mapping.map((column, index) => (
              <StyledTableCell
                key={index}
                align={column.align}
                className={index === 0 ? classes.sticky : ``}
                style={{
                  backgroundColor: `#E0E0E0`,
                  minWidth: column.width,
                  padding: `8px 0`,
                }}
              >
                {column.name}
              </StyledTableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {(docs ?? []).map((document: any, index: number) => {
            // Check if this row is selected
            return (
              <StyledTableRow>
                {mapping.map((entry: any, index2: any) => {
                  return (
                    <TableCell component="div" className={index2 === 0 ? classes.sticky : ``}>
                      <Text
                        tagName="span"
                        style={{ overflow: `hidden`, textOverflow: `ellipsis`, textAlign: entry.align ?? `center` }}
                      >
                        <>
                          {(() => {
                            if (entry.formatter) {
                              return entry.formatter(
                                entry.computed ? entry.computed(document) : document[entry.column],
                                document,
                                index
                                // rowHover
                              );
                            }
                            if (entry.computed) {
                              return entry.computed(document);
                            }
                            return document[entry.column];
                          })()}
                        </>
                      </Text>
                    </TableCell>
                  );
                })}
              </StyledTableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default AnalyticsTable;
